var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "195px",
    height: "145px",
    viewBox: "0 0 195 145",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layout-iOS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14.3.2-Reserva---Cancelar",
    transform: "translate(-90.000000, -223.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(90.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.295855,21.1689007 C100.795456,20.7420374 88.8897368,16.7710176 77.5199222,12.4275553 C66.1501077,8.08409298 54.8892027,3.27125104 42.6861434,0.970270416 C34.8394674,-0.510996487 25.8639349,-0.720176544 19.5402643,3.41920766 C13.4551575,7.40213198 11.4895988,14.2778634 10.43162,20.6587055 C9.63640723,25.4596429 9.16965188,30.5105759 11.3478435,35.0053962 C12.8604766,38.1243899 15.5469129,40.7467935 17.3983758,43.7348371 C23.862073,54.1343171 19.2999717,66.955524 12.2882691,77.1101103 C9.00369442,81.8719327 5.19013035,86.4160718 2.65582168,91.485712 C0.121513002,96.5553523 -1.04710409,102.364776 1.18122052,107.544958 C3.38015683,112.67072 8.61473163,116.520993 14.2970458,119.23013 C25.8172593,124.721532 40.3086812,134.762779 52.6505057,138.399119 C82.3710817,147.155857 104.527483,147.155857 140.863809,138.66272 C151.20517,136.245563 162.141299,128.409072 173.37937,125.156898 C179.037955,123.519367 185.461419,122.775987 189.778041,119.257341 C195.256366,114.78633 196.615143,107.215032 192.943334,101.607986 C186.785621,92.2033867 169.759423,89.873495 165.45663,79.7750302 C163.08655,74.2207044 165.520593,68.032036 168.96421,62.8807645 C176.349317,51.8265339 188.728706,42.1328239 189.380435,29.4986887 C189.829903,20.8253693 183.877908,12.131642 174.675913,8.02627085 C165.029635,3.72362417 151.65623,4.26443114 144.539075,11.3884576 C137.211017,18.7233648 124.333755,21.5447446 113.295855,21.1689007 Z",
    id: "Path",
    fill: "#47F17E",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(58.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0 C17.9431153,0 0,17.9431153 0,40 C0,62.0568847 17.9431153,80 40,80 C62.0568847,80 80,62.0568847 80,40 C80,17.9431153 62.0568847,0 40,0 Z",
    id: "Path",
    fill: "#47F17D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2734375,31.5234375 L38.6065673,53.1896972 C37.956543,53.8397217 37.1032716,54.1668702 36.25,54.1668702 C35.3967284,54.1668702 34.543457,53.8397217 33.8934327,53.1896972 L23.0603028,42.3565673 C21.7565919,41.0534669 21.7565919,38.9465331 23.0603028,37.6434327 C24.3634033,36.3397217 26.4697266,36.3397217 27.7734375,37.6434327 L36.25,46.1199952 L55.5603028,26.8103028 C56.8634033,25.5065919 58.9697266,25.5065919 60.2734375,26.8103028 C61.5765381,28.1134033 61.5765381,30.2197266 60.2734375,31.5234375 Z",
    id: "Path",
    fill: "#FAFAFA"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c207fc0c0ed51b3a482287082372e37f.svg";
export { ForwardRef as ReactComponent };